package com.nonopn.skywatcher.common.homepage

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import eu.codlab.blipya.common_sub_login.generated.resources.Res
import eu.codlab.blipya.common_sub_login.generated.resources.homepage_title_1
import eu.codlab.blipya.common_sub_login.generated.resources.homepage_title_2
import eu.codlab.blipya.common_sub_login.generated.resources.homepage_title_3
import eu.codlab.blipya.common_sub_login.generated.resources.login_background
import eu.codlab.compose.widgets.TextNormal
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun MainImage() {
    val painter = painterResource(Res.drawable.login_background)

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        Image(
            painter = painter,
            contentDescription = "",
            modifier = Modifier.fillMaxSize(),
            alignment = Alignment.Center,
            contentScale = ContentScale.Crop
        )

        Column(
            modifier = Modifier.padding(start = 8.dp, end = 8.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            Spacer(modifier = Modifier.weight(1f))
            Column(
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                MainImageTitle(
                    stringResource(Res.string.homepage_title_1)
                )

                MainImageTitle(
                    stringResource(Res.string.homepage_title_2)
                )

                MainImageTitle(
                    stringResource(Res.string.homepage_title_3)
                )
            }
            Spacer(modifier = Modifier.weight(1f))
        }
    }
}

@Composable
private fun MainImageTitle(text: String) {
    TextNormal(
        text = text,
        color = Color.White,
        fontWeight = FontWeight.Bold,
        fontSize = 32.sp
    )
}
